import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * SecureReveal - Composant anti-scraping pour protéger les données sensibles
 * Les robots ne peuvent pas lire les données car elles sont encodées et révélées au clic
 */
const SecureReveal = ({ 
  type = 'email', // 'email' | 'phone'
  value, // La valeur réelle à révéler
  label = null, // Label personnalisé (optionnel)
  icon: CustomIcon = null, // Icône personnalisée (optionnel)
  className = '',
  showIcon = true
}) => {
  const [isRevealed, setIsRevealed] = useState(false);

  // Encode la valeur pour éviter le scraping même dans le HTML
  const encodedValue = value ? btoa(value) : '';

  const handleReveal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsRevealed(true);
  };

  const getDefaultLabel = () => {
    switch (type) {
      case 'email':
        return 'Voir l\'email';
      case 'phone':
        return 'Voir le numéro';
      default:
        return 'Révéler';
    }
  };

  const getRevealedContent = () => {
    const decodedValue = atob(encodedValue);
    
    if (type === 'email') {
      return (
        <a 
          href={`mailto:${decodedValue}`} 
          className="hover:text-[#00cec9] transition-colors"
          data-testid="secure-reveal-email-link"
        >
          {decodedValue}
        </a>
      );
    }
    
    if (type === 'phone') {
      // Formater le numéro pour le lien tel:
      const telNumber = decodedValue.replace(/\s/g, '');
      return (
        <a 
          href={`tel:${telNumber}`} 
          className="hover:text-[#00cec9] transition-colors"
          data-testid="secure-reveal-phone-link"
        >
          {decodedValue}
        </a>
      );
    }
    
    return decodedValue;
  };

  if (isRevealed) {
    return (
      <span className={`inline-flex items-center space-x-2 ${className}`} data-testid="secure-reveal-revealed">
        {showIcon && CustomIcon && <CustomIcon size={16} className="text-[#00cec9]" />}
        <span>{getRevealedContent()}</span>
      </span>
    );
  }

  return (
    <button
      onClick={handleReveal}
      className={`inline-flex items-center space-x-2 transition-all duration-300 hover:text-[#00cec9] cursor-pointer group ${className}`}
      style={{ color: 'rgba(255, 255, 255, 0.6)' }}
      data-testid={`secure-reveal-${type}-button`}
      aria-label={label || getDefaultLabel()}
    >
      {showIcon && CustomIcon && <CustomIcon size={16} className="text-[#00cec9]" />}
      <span className="underline underline-offset-2 decoration-dotted group-hover:decoration-solid">
        {label || getDefaultLabel()}
      </span>
      <Eye size={14} className="opacity-60 group-hover:opacity-100" />
    </button>
  );
};

export default SecureReveal;
